import { createLogger, type NamedLogEntry, type NamedLogger, type NamedLogMethod } from './utils';

export type { NamedLogEntry, NamedLogger, NamedLogMethod };
export const plog: NamedLogger = createLogger();
